import { render, staticRenderFns } from "./spaceModal.vue?vue&type=template&id=1c0a4a8c&scoped=true"
import script from "./spaceModal.vue?vue&type=script&lang=js"
export * from "./spaceModal.vue?vue&type=script&lang=js"
import style0 from "./spaceModal.vue?vue&type=style&index=0&id=1c0a4a8c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0a4a8c",
  null
  
)

export default component.exports